
































import { Component, Mixins, Vue } from 'vue-property-decorator';
import NotificationsManager from '@/components/NotificationsManager.vue';
import { readIsLoggedIn } from '@/store/main/getters';
import { dispatchCheckLoggedIn } from '@/store/main/actions';
import UpdateMixin from '@/mixins/UpdateMixin';

@Component({
  components: {
    NotificationsManager
  }
})
export default class App extends Mixins(UpdateMixin) {
  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }

  public async created() {
    await dispatchCheckLoggedIn(this.$store);
  }
}
